import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Switch from 'flarum/common/components/Switch';
import CountryFlagPicker from '../../common/components/CountryFlagPicker';
export default function extendUserPreferences() {
  extend('flarum/forum/components/SettingsPage', 'privacyItems', function (items) {
    if (app.forum.attribute('fof-geoip.showFlag')) {
      items.add('ip-country', m(Switch, {
        state: this.user.preferences().showIPCountry,
        onchange: checked => {
          this.showIPCountryLoading = true;
          this.user.savePreferences({
            showIPCountry: checked
          }).then(() => {
            this.showIPCountryLoading = false;
            m.redraw();
          });
        },
        loading: this.showIPCountryLoading
      }, app.translator.trans('fof-geoip.forum.user.settings.ip_country')));
    }
    if (app.forum.attribute('fof-geoip.allowCustomFlag')) {
      items.add('custom-flag', m("div", {
        className: "Form-group"
      }, m("label", null, app.translator.trans('fof-geoip.forum.user.settings.custom_flag_label')), m("p", {
        className: "helpText"
      }, app.translator.trans('fof-geoip.forum.user.settings.custom_flag_help')), m(CountryFlagPicker, {
        value: this.user.preferences().customFlagCountry,
        disabled: this.customFlagLoading,
        onchange: code => {
          this.customFlagLoading = true;
          this.user.savePreferences({
            customFlagCountry: code
          }).then(() => {
            this.customFlagLoading = false;
            m.redraw();
          });
        }
      })));
    }
  });
}
flarum.reg.add('fof-geoip', 'forum/extenders/extendUserPreferences', extendUserPreferences);